<template src="./DeliveryDataComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant} from "@/supports/app.constant";
import {ref, onMounted, computed} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {useRouter} from "vue-router";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import {useDeliveryStore} from "@/stores/delivery.js";
import TabDeliveryOwnerComponent
  from "@/pages/invoice/delivery-data/list-exchange-delivery/tab-exchange/tab-delivery-owner/TabDeliveryOwnerComponent.vue";
import TabDeliveryPartnerComponent
  from "@/pages/invoice/delivery-data/list-exchange-delivery/tab-exchange/tab-delivery-partner/TabDeliveryPartnerComponent.vue";

export default {
  name: 'DeliveryDataComponent',
  components: {
    TabDeliveryPartnerComponent,
    TabDeliveryOwnerComponent,
    PaginateComponent,
    ButtonAddComponent,
    IconTrash,
    IconEdit,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome
  },
  setup() {
    const tabCurrent = ref(AppConstant.TAB_OWNER)
    function changeTab(type = 'owner') {
      tabCurrent.value = AppConstant.TAB_OWNER
      if(type === 'partner') {
        tabCurrent.value = AppConstant.TAB_PARTNER
      }
    }

    return {
      tabCurrent,
      changeTab,
      CommonService,
      AppConstant
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;

  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }

  .container-fluid {
    padding-top: 30px;

    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46, 35, 94, .07);
      .nav-item {
        width: 200px;
        button {
          background-color: #ffffff !important;
        }
        button.active {
          border-bottom: 2px solid #00bd7e;
          color: #00bd7e
        }
      }
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;

        .btn-create-data {
          width: 200px;
          margin-top: 50px;
        }

        .list-partners-component {
          margin-top: 30px;

          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }

          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;

            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
        }

      }
    }
  }
}
</style>
